import React, { useEffect, useState } from 'react';
import InfoCards from './../common/InfoCards';
import TableWithPagination from './../common/TableWithPagination';
import { Icon } from '@iconify/react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';
import { useApi } from './../../hooks/useApi';

const ResultsModule = () => {
  const { get } = useApi();
  const [results, setResults] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [vistaActiva, setVistaActiva] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const formatDate = (date) => (date ? dayjs(date).format('DD/MM/YYYY HH:mm') : '');
  const dateYmD = (date) => (date ? dayjs(date).format('YYYY-MM-DD') : '');

  //const [dateRange, setDateRange] = useState([null, null]);
  //const [startDate, endDate] = dateRange;
    const today = new Date();
    const startOfDay = new Date(today.setHours(0, 0, 0, 0));
    const endOfDay = new Date(new Date().setHours(23, 59, 59, 999));

    const [dateRange, setDateRange] = useState([startOfDay, endOfDay]);
    const [startDate, endDate] = dateRange;


 useEffect(() => {
    if (startDate && endDate) {
        fetchData();
    }
    }, [startDate, endDate]);


  useEffect(() => {
    filtrarResultados();
  }, [dateRange, results, vistaActiva]);

  const fetchData = async () => {
       
      setLoading(true); 
      const data = await get('resultados', {
        params: {
            fechaInicio: dateYmD(startDate),
            fechaFin: dateYmD(endDate),
        }
      });
      console.log('Fetched results:', data);
      setResults(data);
      setFiltered(data);
      setLoading(false);
    
  };

  const filtrarResultados = () => {
    let data = [...results];

    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      data = data.filter((item) => {
        const fecha = new Date(item.fechaResultado);
        return fecha >= start && fecha <= end;
      });
    }

    if (vistaActiva && ['E', 'W', 'S'].includes(vistaActiva)) {
    data = data.filter((item) => (item.estatus || '').toUpperCase() === vistaActiva);
    }


    setFiltered(data);
  };

  const contar = (estatus) =>
  results.filter((r) => (r.estatus || '').toUpperCase() === estatus).length;




  const cardsData = [
  {
    estatus: 'E',
    label: 'Errores',
    value: contar('E'),
    icon: 'mdi:alert-circle-outline',
    bgColor: 'bg-red-400',
    textColor: 'text-red-500',
  },
  {
    estatus: 'W',
    label: 'Advertencias',
    value: contar('W'),
    icon: 'mdi:alert-outline',
    bgColor: 'bg-yellow-400',
    textColor: 'text-yellow-500',
  },
  {
    estatus: 'S',
    label: 'Éxitos',
    value: contar('S'),
    icon: 'mdi:check-circle-outline',
    bgColor: 'bg-green-400',
    textColor: 'text-green-500',
  },
];



  const columnsResults = [
        { header: 'ID', accessor: 'id' },
        { header: 'Archivo Log', accessor: 'nombreArchivoLog' },
        {
            header: 'Estatus',
            accessor: 'estatus',
            Cell: ({ value }) => {
            const estatus = (value || '').toUpperCase();

            const iconMap = {
                E: { icon: 'mdi:alert-circle-outline', color: 'text-red-500', label: 'Error' },
                W: { icon: 'mdi:alert-outline', color: 'text-yellow-500', label: 'Advertencia' },
                S: { icon: 'mdi:check-circle-outline', color: 'text-green-500', label: 'Éxito' },
            };

            const { icon, color, label } = iconMap[estatus] || {
                icon: 'mdi:help-circle-outline',
                color: 'text-gray-400',
                label: 'Desconocido',
            };

            return (
                <span className={`flex items-center gap-1 ${color}`}>
                <Icon icon={icon} width={18} />
                <span className="text-sm">{label}</span>
                </span>
            );
            },
        },
        { header: 'Pedido Qualtia', accessor: 'pedidoQualtia' },
        { header: 'Tipo Documento', accessor: 'tipoDocumento' },
        { header: 'ID Cliente', accessor: 'idCliente' },
        { header: 'Pedido SAP', accessor: 'pedidoSAP' },
        { header: 'Mensaje', accessor: 'mensaje' },
        { header: 'Fecha Resultado', accessor: 'fechaResultado' },
        { header: 'Fecha Registro', accessor: 'fechaRegistro' },
        { header: 'Referencia Cliente', accessor: 'referenciaCliente' },
        ];

  return (
    <div className="p-4">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 gap-4">
        <h1 className="text-2xl font-bold">Results</h1>

        <div className="w-full md:w-auto">
            <label className="block text-sm font-medium text-slate-700 mb-1">Rango de fechas:</label>
            <div className="relative">
            <Icon
                icon="mdi:calendar"
                className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 w-5 h-5 z-20"
            />
            <DatePicker
                selectsRange
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => {
                setDateRange(update);
                }}
                className="w-full md:w-64 pl-10 pr-3 py-2 text-sm bg-white text-slate-700 rounded-md border border-gray-300 focus:ring-2 focus:ring-[#233F93] focus:outline-none shadow-sm"
                calendarClassName="!z-50"
                portal={true}
                dateFormat="dd/MM/yyyy"
                isClearable={true}
            />
            </div>
        </div>
        </div>


      {/* Cards */}
      <InfoCards
        cardsData={cardsData}
        estatusActivo={vistaActiva}
        onCardClick={(estatus) => {
          setVistaActiva(estatus);
        }}
        loading={loading}
        error={error}
      />

      {/* Tabla */}
      <div className="mt-6 bg-white shadow rounded p-4">
        <h2 className="text-lg font-semibold mb-4">Detalles</h2>
        <div className="overflow-x-auto">
          <TableWithPagination
            columns={columnsResults}
            data={filtered.map((r) => ({
              ...r,
              fechaResultado: formatDate(r.fechaResultado),
              fechaRegistro: formatDate(r.fechaRegistro),
            }))}
            showView={false}
            showEdit={false}
            showDelete={false}
          />
        </div>
      </div>
    </div>
  );
};

export default ResultsModule;
